import React from 'react'

import containerLayout from '../../assets/js/ContainerLayout.enum'
import Book from './ContainerLayouts/Book'
import Polaroid from './ContainerLayouts/Polaroid'
import RoundedPhoto from './ContainerLayouts/RoundedPhoto'
import Header from './Header'
import './Container.css'

const container = props => {
  let layout = containerLayout.BOOK
  if (props.layout) {
    layout = props.layout
  }

  let container
  switch (layout) {
    case containerLayout.BOOK:
      container = <Book headerProps={props.headerProps} items={props.items} />
      break
    case containerLayout.POLAROID:
      container = (
        <Polaroid headerProps={props.headerProps} items={props.items} />
      )
      break
    case containerLayout.ROUNDED_PHOTO:
      container = (<RoundedPhoto headerProps={props.headerProps} items={props.items} />);
      break
    default:
      container = (
      <div className="Container_Default"> 
        <Header headerProps={props.headerProps} />
        {props.items[0]}
      </div>)
  }

  return <div className="container">{container}</div>
}

export default container
